<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <Aviso
          mensagem="Cálculo de acordo com a Portaria TCDF 212/2002 c/c Emenda Regimental 1/2019."
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="8">
        <FormCalculo tipo="encargosMoratorios"/>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <Resultados nome="Encargos Moratórios" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FormCalculo from "@/components/FormCalculo.vue";
import Resultados from "@/components/Resultados.vue";
import Aviso from "@/components/Aviso.vue";
export default {
  components: {
    FormCalculo,
    Resultados,
    Aviso
  }
};
</script>

<style lang="scss" scoped></style>
